/**
 * HR Services Module
 * Exports all HR management services and factory functions
 */
// Service exports
export * from './DutyService';
export * from './EmployeeDutyService';
export * from './EmployeeFileCategoryService';
export * from './EmployeeFileTypeService';
export * from './EmployeeFileService';
export * from './EmployeeStatusService';
export * from './EmployeeTypeService';
export * from './EmployeeService';
export * from './LeaveDocumentTypeService';
export * from './LeaveDocumentService';
export * from './LeaveDutyService';
export * from './LeaveNotificationQueueService';
export * from './LeaveStatusService';
export * from './LeaveTypeService';
export * from './LeaveService';
export * from './PolicyService';
export * from './PolicyCategoryService';
export * from './PolicySignatureService';
// Service imports for factory
import { DutyService } from './DutyService';
import { EmployeeDutyService } from './EmployeeDutyService';
import { EmployeeFileCategoryService } from './EmployeeFileCategoryService';
import { EmployeeFileTypeService } from './EmployeeFileTypeService';
import { EmployeeFileService } from './EmployeeFileService';
import { EmployeeStatusService } from './EmployeeStatusService';
import { EmployeeTypeService } from './EmployeeTypeService';
import { EmployeeService } from './EmployeeService';
import { LeaveDocumentTypeService } from './LeaveDocumentTypeService';
import { LeaveDocumentService } from './LeaveDocumentService';
import { LeaveDutyService } from './LeaveDutyService';
import { LeaveNotificationQueueService } from './LeaveNotificationQueueService';
import { LeaveStatusService } from './LeaveStatusService';
import { LeaveTypeService } from './LeaveTypeService';
import { LeaveService } from './LeaveService';
import { PolicyService } from './PolicyService';
import { PolicyCategoryService } from './PolicyCategoryService';
import { PolicySignatureService } from './PolicySignatureService';
/**
 * Create all HR services with shared configuration
 * @param http - HTTP client instance
 * @param config - Service configuration (servicePath, endpoints)
 * @returns Object containing all HR service instances
 */
export function createHrServices(http, config) {
    return {
        duty: new DutyService(http, config),
        employeeDuty: new EmployeeDutyService(http, config),
        employeeFileCategory: new EmployeeFileCategoryService(http, config),
        employeeFileType: new EmployeeFileTypeService(http, config),
        employeeFile: new EmployeeFileService(http, config),
        employeeStatus: new EmployeeStatusService(http, config),
        employeeType: new EmployeeTypeService(http, config),
        employee: new EmployeeService(http, config),
        leaveDocumentType: new LeaveDocumentTypeService(http, config),
        leaveDocument: new LeaveDocumentService(http, config),
        leaveDuty: new LeaveDutyService(http, config),
        leaveNotificationQueue: new LeaveNotificationQueueService(http, config),
        leaveStatus: new LeaveStatusService(http, config),
        leaveType: new LeaveTypeService(http, config),
        leave: new LeaveService(http, config),
        policy: new PolicyService(http, config),
        policyCategory: new PolicyCategoryService(http, config),
        policySignature: new PolicySignatureService(http, config),
    };
}
//# sourceMappingURL=index.js.map